const LABELS = {
  ready: "Live",
  onboarding: "Onboarding",
  suspended: "Suspended",
  active: "Active",
  revoked: "Revoked",
  expired: "Expired",
} as const;

export type BadgeStatus = keyof typeof LABELS;

export function StatusBadge({ status }: { status: BadgeStatus }) {
  return <span className={`badge badge-${status}`}>{LABELS[status]}</span>;
}
